module.exports = __webpack_public_path__ + "img/hohlsaum_reinweiss_ral9010.499d17a8.jpg";